import React from 'react';

export const IdentificationFormNote = () => {
  return(
    <div className="form-notes">
      <div className="form-notes__heading">※ご登録の前に必ずご確認ください。</div>
      <ul className="list-base font-bold">
        <li className="list-base__item">本人確認書類は<span className="font-emphasis">2種類必要</span></li>
        <li className="list-base__item"><span className="font-emphasis">有効期限が切れていないこと</span></li>
        <li className="list-base__item">領収書・証明書は<span className="font-emphasis">発行から6ヶ月以内で氏名・現住所・発行日の３点が記載</span>されたもの</li>
        <li className="list-base__item"><span className="font-emphasis">全ての提出書類の住所が一致していること</span></li>
        <li className="list-base__item">登録可能な書類と組み合わせのパターンは以下のみ可能</li>
      </ul>
      <div className="form-notes__item">
        <div className="form-notes__index">A群(有効期限内で現住所が記載されているもの)</div>
        <ul className="list-short">
          <li className="list-short__item">運転免許証・運転経歴証明書</li>
          <li className="list-short__item">パスポート <br className="is-sp" />※日本国発行のもので所持人記入欄に現住所が記載されていること</li>
          <li className="list-short__item">在留カード・特別永住者証明書</li>
          <li className="list-short__item">国民年金手帳</li>
          <li className="list-short__item">個人番号カード（マイナンバーカード）</li>
          <li className="list-short__item">写真付き住民基本台帳カード</li>
        </ul>
      </div>
      <div className="form-notes__item">
        <div className="form-notes__index">B群(発行から6ヶ月以内で氏名・現住所・発行日の３点が記載されているもの)</div>
        <ul className="list-short">
          <li className="list-short__item">公共料金(電気/都市ガス/水道/NHKのいずれか)の領収書</li>
          <li className="list-short__item">社会保険料の領収書</li>
          <li className="list-short__item">国税・地方税の領収書または納税証明書</li>
        </ul>
      </div>
      <div className="form-notes__item">
        <div className="form-notes__index">可能な組み合わせ(現住所が記載されているものに限ります)</div>
        <ul className="list-short">
          <li className="list-short__item">A群から2点</li>
          <li className="list-short__item">A群から1点＋B群から1点</li>
        </ul>
      </div>
      <div className="form-notes__item">
        <div className="form-notes__index">NGな組み合わせ</div>
        <ul className="list-short">
          <li className="list-short__item">B群から2点</li>
          <li className="list-short__item">A郡またはB郡の本人確認書類に記載された住所が一致しない</li>
        </ul>
      </div>
    </div>
  );
};
